/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarnings
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarnings
     */
    'detectedDpi'?: GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarnings
     */
    'calculatedDpi'?: GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarnings
     */
    'colorGradation'?: GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarnings
     */
    'heightMillis'?: GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarnings
     */
    'widthMillis'?: GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsWidthMillisEnum;
}

export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsDetectedDpiEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsDetectedDpiEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsDetectedDpiEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsCalculatedDpiEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsCalculatedDpiEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsCalculatedDpiEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsColorGradationEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsColorGradationEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsColorGradationEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsHeightMillisEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsHeightMillisEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsHeightMillisEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsWidthMillisEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsWidthMillisEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsWidthMillisEnum];


